
import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface CardDescriptionProps {
  description?: string;
  maxLength?: number;
  maxResidents?: number;
  className?: string;
  category?: string;
}

export function CardDescription({ description, maxLength = 120, maxResidents, className, category }: CardDescriptionProps) {
  // Clean literal \n\n from description text
  const cleanDescription = description
    ?.replace(/\\n\\n/g, ' ')
    .replace(/\\n/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  // Function to truncate text and add ellipsis if it exceeds the given length
  const truncateText = (text: string | undefined, maxTextLength: number): string => {
    if (!text) return '';
    return text.length > maxTextLength ? `${text.substring(0, maxTextLength)}...` : text;
  };

  const truncatedDescription = truncateText(cleanDescription, maxLength);
  const needsTruncation = cleanDescription && cleanDescription.length > maxLength;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            {category && (
              <p className="text-xs text-grandpal-green font-medium mb-1">
                {category}
              </p>
            )}
            <p className={`text-sm text-grandpal-gray mb-2 line-clamp-3 min-h-[40px] ${className || ''}`}>
              {truncatedDescription || "No description available"}
            </p>
            {maxResidents && (
              <p className="text-xs text-grandpal-gray">
                <span className="font-medium">Capacity:</span> {maxResidents} residents
              </p>
            )}
          </div>
        </TooltipTrigger>
        {needsTruncation && (
          <TooltipContent className="max-w-xs">
            {cleanDescription}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
